import { memo } from "react";
import { useEntitiesById } from "@hooks/useEntities";
import { getCloseOptionDescription } from "../../taskClose";
import { Picker } from "@design-system/Picker/Picker.lib";

interface CloseSelectItemProps {
    id: string;
    name: string;
    entityId?: number;
    startDate?: string | null;
    endDate?: string | null;
}

/**
 * Close / close stage row shared by CloseSelectCell, TaskDetail and
 * TaskCreationForm: the close name with "entity · date range" below it.
 */
export const CloseSelectItem = memo(
    ({ id, name, entityId, startDate, endDate }: CloseSelectItemProps) => {
        const entitiesById = useEntitiesById();
        const entityName = entityId
            ? (entitiesById.get(entityId)?.name ?? undefined)
            : undefined;

        return (
            <Picker.Item
                value={id}
                description={getCloseOptionDescription({
                    entityName,
                    startDate,
                    endDate,
                })}
            >
                {name}
            </Picker.Item>
        );
    },
);
CloseSelectItem.displayName = "CloseSelectItem";
